const hexToHsl = (hex) => {
  const clean = hex.replace('#', '')
  const full = clean.length === 3 ? clean.split('').map((c) => c + c).join('') : clean
  const num = Number.parseInt(full, 16)
  const r = ((num >> 16) & 255) / 255
  const g = ((num >> 8) & 255) / 255
  const b = (num & 255) / 255
  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  const l = (max + min) / 2
  let h = 0
  let s = 0
  if (max !== min) {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break
      case g: h = (b - r) / d + 2; break
      default: h = (r - g) / d + 4
    }
    h *= 60
  }
  return { h, s: s * 100, l: l * 100 }
}

const hslToHex = ({ h, s, l }) => {
  const sNorm = s / 100
  const lNorm = l / 100
  const c = (1 - Math.abs(2 * lNorm - 1)) * sNorm
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1))
  const m = lNorm - c / 2
  let [r, g, b] = [0, 0, 0]
  const hh = ((h % 360) + 360) % 360
  if (hh < 60) [r, g, b] = [c, x, 0]
  else if (hh < 120) [r, g, b] = [x, c, 0]
  else if (hh < 180) [r, g, b] = [0, c, x]
  else if (hh < 240) [r, g, b] = [0, x, c]
  else if (hh < 300) [r, g, b] = [x, 0, c]
  else [r, g, b] = [c, 0, x]
  const toHex = (v) =>
    Math.round((v + m) * 255).toString(16).padStart(2, '0')
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}

const HARMONIES = {
  complementar: (h) => [h, h + 180],
  analoga: (h) => [h - 30, h, h + 30],
  triade: (h) => [h, h + 120, h + 240],
  tetrade: (h) => [h, h + 90, h + 180, h + 270],
}

export const generatePalette = (baseHex, harmony) => {
  const { s, l } = hexToHsl(baseHex)
  const hues = HARMONIES[harmony](hexToHsl(baseHex).h)
  return hues.map((h) => hslToHex({ h, s, l }))
}

export const toCssVariables = (colors) =>
  colors.map((hex, i) => `  --color-${i + 1}: ${hex};`).join('\n')
